import React, {Component} from 'react';
import {connect} from 'react-redux';
import Translator from "../helpers/Translator";
import {DOMAIN} from "./FlightsContainer";
import IframeHelper from "../helpers/IframeHelper";
import Loader from "../helpers/Loader";

class Preloader extends Component {

    constructor(props) {
        super(props);
        this.state = {showAnimation: 'allow'};
    }

    getDepartureCode() {
        return this.props.parameters['search-params'].departureCity ?
            this.props.parameters['search-params'].departureCity :
            this.props.parameters['search-params'].departureAirport;
    }

    getArrivalCode() {
        return this.props.parameters['search-params'].arrivalCity ?
            this.props.parameters['search-params'].arrivalCity :
            this.props.parameters['search-params'].arrivalAirport;
    }

    appendHideClass() {
        if (!this.props.flights.loading) {
            return 'slow-hide';
        }

        return null;
    }

    getAnimationClassName() {
        if (!Loader.showLoader(this.props.flights) || this.state.showAnimation === 'hide') {
            return 'd-none';
        } else if (this.state.showAnimation === 'allow' && this.appendHideClass()) {
            return this.appendHideClass();
        }

        return '';
    }

    componentDidMount() {
        IframeHelper.updateHeight(this.props.parameters.projectUrl);
    }

    render() {
        const translator = new Translator(this.props.translator, DOMAIN);
        const route = JSON.parse(this.props.parameters.route);

        return (
            <div className={this.getAnimationClassName()}>
                <div className="fs-loader mb-4">
                    <div className="fs-loader-route">
                        <div className="fs-loader-point">
                            <div className="fs-loader-code">{this.getDepartureCode()}</div>
                            <div className="fs-loader-city">{route.from.general}</div>
                        </div>
                        <div className="fs-loader-path">
                            <div className="fs-loader-dash"></div>
                            <div className="fs-loader-plane">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" stroke="none">
                                    <path d="M17.8 19.2 16 11l3.5-3.5c1-1 1.5-2.4 1.5-3.5a2.12 2.12 0 0 0-2-2c-1.1 0-2.5.5-3.5 1.5L12 8 3.8 6.2c-.5-.1-.9.1-1.1.5l-.3.5c-.2.5-.1 1 .3 1.3L9 12l-2 3H4l-1 1 3 2 2 3 1-1v-3l3-2 3.5 5.3c.3.4.8.5 1.3.3l.5-.2c.4-.3.6-.7.5-1.2z"/>
                                </svg>
                            </div>
                        </div>
                        <div className="fs-loader-point">
                            <div className="fs-loader-code">{this.getArrivalCode()}</div>
                            <div className="fs-loader-city">{route.to.general}</div>
                        </div>
                    </div>
                    <div className="fs-loader-bar">
                        <div className="fs-loader-bar-fill"></div>
                    </div>
                    <div className="fs-loader-status">
                        {translator.trans('Searching for flights offers')}
                        <span className="fs-loader-dot">.</span>
                        <span className="fs-loader-dot">.</span>
                        <span className="fs-loader-dot">.</span>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        translator: state.TranslationsReducer.translations,
        parameters: state.ParametersReducer.parameters,
        flights: state.FlightsReducer
    }
}

export default connect(mapStateToProps)(Preloader);



// WEBPACK FOOTER //
// ./src/components/Preloader.js